import {
  MaintainTitle,
  MeshBackgroundImage,
  Unit,
  Weight,
  WeightTransitionImage,
  WeightTransitionWrapper,
  Wrapper,
} from "./styled"
import WeightInfo from "../WeightInfo"
import { IGoal } from "features/onboarding/types"
import { getUSDisplayDateWithYear } from "utils/dateTime"
import { MAINTAIN_WEIGHT_TYPES } from "config"
import { Fragment } from "react"
import { FlexBox } from "components/Common/FlexBox"
import gainWeightTransition from "assets/images/goal/gain-weight-transition.png"
import loseWeightTransition from "assets/images/goal/lose-weight-transition.png"
import meshBg from "assets/images/goal/mesh.png"

const WeightTransition = ({
  goal,
  displayedStartWeight,
  displayedTargetWeight,
  style,
}: {
  goal: IGoal
  displayedStartWeight: string
  displayedTargetWeight: string
  style?: React.CSSProperties
}) => {
  const isMaintainWeight = MAINTAIN_WEIGHT_TYPES.includes(goal.typeName)
  const isGainWeight = goal.typeName === "BUILDING"
  const [weightNumber, unit] = displayedStartWeight.split(" ")
  return (
    <Wrapper style={style}>
      <WeightTransitionWrapper $isMaintainWeight={isMaintainWeight}>
        <MeshBackgroundImage src={meshBg} alt="" />
        {isMaintainWeight ? (
          <FlexBox
            $gap={isMaintainWeight ? 6 : 12}
            $justify="center"
            $alignItems="center"
            $direction="column"
            style={{ width: "100%" }}
          >
            <MaintainTitle>Maintain the weight at</MaintainTitle>
            <FlexBox $gap={4} $alignItems="flex-end">
              <Weight>{weightNumber}</Weight>
              <Unit>{unit}</Unit>
            </FlexBox>
          </FlexBox>
        ) : (
          <Fragment>
            <WeightTransitionImage
              src={isGainWeight ? gainWeightTransition : loseWeightTransition}
              alt="transition"
            />
            <WeightInfo
              label="start"
              type="start"
              weight={displayedStartWeight}
              date={getUSDisplayDateWithYear(goal?.startDate)}
            />

            <WeightInfo
              label="goal"
              type={goal.typeName==='BUILDING' ? 'gain': 'lose'}
              weight={displayedTargetWeight}
              date={getUSDisplayDateWithYear(goal?.reachedOn)}
            />
          </Fragment>
        )}
      </WeightTransitionWrapper>
    </Wrapper>
  )
}

export default WeightTransition
